import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "Was kostet eine typische PV-Anlage in der Schweiz?",
    a: "Für ein Einfamilienhaus mit 8–12 kWp rechnen Sie mit CHF 18'000 – 28'000 schlüsselfertig. Mit Speicher kommen ca. CHF 8'000 hinzu. Die Einmalvergütung (EIV) von Pronovo reduziert die Investition um typischerweise CHF 2'500 – 4'500.",
  },
  {
    q: "Wie lange dauert die Installation?",
    a: "Die eigentliche Dachmontage dauert je nach Anlagengrösse 2–4 Tage. Inklusive Planung, Anmeldung beim Netzbetreiber und Pronovo-Antrag ist der gesamte Prozess in 8–12 Wochen abgeschlossen.",
  },
  {
    q: "Wann amortisiert sich meine Solaranlage?",
    a: "In der Schweiz liegt die Amortisationszeit bei guten Anlagen mit hohem Eigenverbrauch typischerweise bei 10–14 Jahren. Mit Speicher und Wallbox erhöht sich der Eigenverbrauch und die Amortisation verbessert sich.",
  },
  {
    q: "Welche Förderungen kann ich beanspruchen?",
    a: "Bundesweit gibt es die Einmalvergütung von Pronovo. Viele Kantone und Gemeinden bieten zusätzliche Förderbeiträge an. Wir prüfen für Sie alle Möglichkeiten und übernehmen die komplette Antragstellung.",
  },
  {
    q: "Wie lange hält eine Photovoltaikanlage?",
    a: "Moderne Solarmodule haben eine Lebensdauer von 30+ Jahren. Wir geben 25 Jahre Leistungsgarantie auf die Module. Wechselrichter werden typischerweise nach 12–15 Jahren ersetzt.",
  },
  {
    q: "Brauche ich eine Baubewilligung?",
    a: "Für Anlagen auf bestehenden Dächern reicht in der Regel eine Meldung an die Gemeinde. Bei denkmalgeschützten Gebäuden oder Freiflächenanlagen ist eine Bewilligung nötig. Wir kümmern uns um die Formalitäten.",
  },
];

// Strukturierte Daten aus derselben Quelle wie die sichtbare Liste – kein Drift.
const faqJsonLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative py-20 md:py-28 bg-[#FAF7EF]"
    >
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }}
      />

      <div className="max-w-4xl mx-auto px-6 lg:px-10">
        <div className="mb-10 text-center">
          <div className="text-sm text-[#EAB308] font-semibold uppercase tracking-widest">
            FAQ
          </div>
          <h2 className="mt-3 font-display font-semibold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#1A1D20]">
            Häufig gestellte Fragen.
          </h2>
        </div>

        <div className="bg-white rounded-2xl border border-black/5 p-2 md:p-4">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="border-b last:border-b-0 border-black/5 px-4"
              >
                <AccordionTrigger className="text-left font-display text-lg text-[#1A1D20] hover:no-underline py-5">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-[#4B5563] leading-relaxed pb-5 text-base">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>

        <p className="mt-8 text-center text-sm text-[#4B5563]">
          Ihre Frage war nicht dabei?{" "}
          <a
            href="#kontakt"
            data-testid="faq-contact-link"
            className="font-semibold text-[#1A1D20] underline underline-offset-4 decoration-[#EAB308] decoration-2 hover:text-[#CA9A06]"
          >
            Fragen Sie uns direkt
          </a>{" "}
          – wir antworten innerhalb eines Werktags.
        </p>
      </div>
    </section>
  );
}
